import React from 'react';
import { View, Text, StyleSheet, TouchableOpacity } from 'react-native';
import { useAuth } from '../contexts/AuthContext';
import { useAuthModals } from '../contexts/AuthModalsContext';
import SplashScreen from '../screens/SplashScreen';
import { NETFLIX_COLORS, NETFLIX_SPACING } from '../theme/netflixTheme';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export function ProtectedRoute({ children }: ProtectedRouteProps) {
  const { isAuthenticated, isLoading } = useAuth();
  const { openAuthSelectionModal } = useAuthModals();

  if (isLoading) {
    return <SplashScreen />;
  }

  if (!isAuthenticated) {
    return (
      <View style={styles.container}>
        <div style={overlayStyle}>
          <View style={styles.modal}>
            <Text style={styles.title}>Acesso Restrito</Text>
            <Text style={styles.subtitle}>Você precisa estar logado para acessar esta página</Text>
            <TouchableOpacity style={styles.button} onPress={openAuthSelectionModal}>
              <Text style={styles.buttonText}>Entrar</Text>
            </TouchableOpacity>
          </View>
        </div>
        <View style={styles.contentBlurred}>
          {children}
        </View>
      </View>
    );
  }

  return <>{children}</>;
}

const overlayStyle: React.CSSProperties = {
  position: 'fixed',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  backgroundColor: 'rgba(0,0,0,0.7)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  zIndex: 999,
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    position: 'relative',
  },
  modal: {
    backgroundColor: NETFLIX_COLORS.surface,
    borderRadius: 16,
    padding: NETFLIX_SPACING.xl,
    maxWidth: 400,
    alignItems: 'center',
  },
  title: {
    fontSize: 24,
    fontWeight: '700',
    color: NETFLIX_COLORS.textPrimary,
    marginBottom: NETFLIX_SPACING.sm,
    textAlign: 'center',
  },
  subtitle: {
    fontSize: 14,
    color: NETFLIX_COLORS.textSecondary,
    textAlign: 'center',
    marginBottom: NETFLIX_SPACING.xl,
    lineHeight: 20,
  },
  button: {
    backgroundColor: NETFLIX_COLORS.primary,
    borderRadius: 8,
    padding: NETFLIX_SPACING.md,
    width: '100%',
    alignItems: 'center',
  },
  buttonText: {
    color: NETFLIX_COLORS.white,
    fontSize: 14,
    fontWeight: '700',
    letterSpacing: 0.5,
  },
  contentBlurred: {
    opacity: 0.3,
    pointerEvents: 'none',
  },
});
